/* eslint-disable no-unused-vars */
import { createContext, useContext, ReactNode } from 'react';
import { StateInterface } from 'src/App/Profil/CompletProfilStep';
import { AnyAction, Dispatch } from 'redux';
// import { PDFDocument } from 'pdf-lib';
import Teachr from '../Objects/models/Teachr';

interface ProfilContextType {
    nextStep: (step: number) => void;
    teachr: Teachr;
    dispatch: Dispatch<AnyAction>
    currentProcuration?: number;
    setState: React.Dispatch<React.SetStateAction<StateInterface>>,
    formData?: any; // Remplacez 'any' par le type approprié pour vos données de formulaire
    handleRefreshSiret?: () => Promise<void>
}

const ProfilContext = createContext<ProfilContextType | null>(null);

/**
 * Hook personnalisé pour utiliser le context de procuration
 * @throws Error si utilisé en dehors du ProcurationProvider
 */
export const useProfilContext = () => {
    const context = useContext(ProfilContext);
    if (!context) {
        throw new Error('useProfilContext doit être utilisé à l\'intérieur d\'un ProcurationProvider');
    }
    return context;
};

interface ProfilProviderProps {
    children: ReactNode ;
    value: ProfilContextType;
}

/**
 * Provider pour le context de procuration
 * Encapsule les composants qui ont besoin d'accéder aux données de procuration
 */
export const ProfilProvider = ({ children, value }: ProfilProviderProps) => {
    return (
        <ProfilContext.Provider value={value}>
            {children}
        </ProfilContext.Provider>
    );
};

export type { ProfilContextType };
